import Link from './link';

export default Link;
export type * from './types';
